import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "terms",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "terms" */ "./components/Terms"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
